module.exports = __webpack_public_path__ + "media/images/1-0e09847d524dbf3c1c307caa8e8ed52a.jpg";